import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/gitlab-runner/builds/pG9KGa4F5/0/sim-sol/website/layouts/default.vue")),
  error: defineAsyncComponent(() => import("/home/gitlab-runner/builds/pG9KGa4F5/0/sim-sol/website/layouts/error.vue")),
  print: defineAsyncComponent(() => import("/home/gitlab-runner/builds/pG9KGa4F5/0/sim-sol/website/layouts/print.vue"))
}